import Chart from './components/Chart';

export default { Chart };



// WEBPACK FOOTER //
// ./src/index.js